import { Snippet } from '../../dataModels';

export const dataEntryTableSnippetNoStaticText: Snippet = {
  shiftsummaryDisplyId: '31422ed4-22a9-ec11-a2ed-005056b126a7',
  name: 'Control of Defeat',
  displayName: 'Control of Defeat',
  description: null,
  order: 8,
  type: 'DataEntryTable',
  enableEdit: 'True',
  enableComment: true,
  isEdited: false,
  maxRows: 10,
  canAddDeleteRows: 'True',
  configuration: {
    rowTitleKey: 'EQUIPMENT DEFEATED',
    columnCount: 5,
    columns: [
      {
        id: 1,
        name: 'EQUIPMENT DEFEATED',
        displayName: 'EQUIPMENT DEFEATED',
        controlType: 'Text - Single Line',
        controlValues: null,
        visible: true,
      },
      {
        id: 2,
        name: 'DESCRIPTION',
        displayName: 'DESCRIPTION',
        controlType: 'Text',
        controlValues: null,
        visible: true,
      },
      {
        id: 3,
        name: 'DECOMMISSION TIME',
        displayName: 'DECOMMISSION DATE',
        controlType: 'Time',
        controlValues: null,
        visible: true,
      },
      {
        id: 4,
        name: 'DECOMMISSION DATE',
        displayName: 'DECOMMISSION DATE',
        controlType: 'Date',
        controlValues: null,
        visible: true,
      },
      {
        id: 5,
        name: 'ERSD',
        displayName: 'ERSD',
        controlType: 'DateTime',
        controlValues: null,
        visible: true,
      },
      {
        id: 6,
        name: 'ERE',
        displayName: 'ERE',
        controlType: 'Checkbox',
        controlValues: null,
        visible: true,
      },
      {
        id: 7,
        name: 'MAX',
        displayName: 'MAX',
        controlType: 'Numeric',
        controlValues: null,
        visible: 'True',
      },
      {
        id: 8,
        name: 'TASK COMPLETED',
        displayName: 'TASK COMPLETED',
        controlType: 'Dropdown',
        controlValues: ['YES', 'NO'],
        visible: 'True',
      },
    ],
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 6,
      rowData: [
        {
          'EQUIPMENT DEFEATED': 'CBR rack safety showers',
          DESCRIPTION: 'safety showers',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '03/20/2022',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
        {
          'EQUIPMENT DEFEATED': '19-T-1930A',
          DESCRIPTION: 'S. Flare Pilot',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '01/26/2022',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
        {
          'EQUIPMENT DEFEATED': '21TSV63/21TSV64',
          DESCRIPTION: 'Tank 547 Shell Fill/Suction',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '11/02/2021',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
        {
          'EQUIPMENT DEFEATED': '21TSV121',
          DESCRIPTION: 'TNK 1623 Shell Fill',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '10/24/2021',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
        {
          'EQUIPMENT DEFEATED': '21TSV122',
          DESCRIPTION: 'TNK 1623 Shell Suction',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '10/24/2021',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
        {
          'EQUIPMENT DEFEATED': '24A-1461B',
          DESCRIPTION: 'O2 Gas Sensor Loop',
          'DECOMMISSION TIME': null,
          'DECOMMISSION DATE': '01/08/2022',
          ERSD: null,
          ERE: 'False',
          MAX: 50,
          'TASK COMPLETED': 'YES',
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
};

export const dataEntryTableSnippetWithStaticText: Snippet = {
  shiftsummaryDisplyId: '2c422ed4-22a9-ec11-a2ed-005056b126a7',
  name: 'Structured Rounds',
  displayName: 'Structured Rounds',
  description: null,
  order: 1,
  type: 'DataEntryTable',
  enableEdit: 'True',
  enableComment: true,
  isEdited: false,
  maxRows: 1,
  canAddDeleteRows: 'False',
  configuration: {
    rowTitleKey: 'ITEM',
    columnCount: 3,
    columns: [
      {
        id: 1,
        name: 'ITEM',
        displayName: 'ITEM',
        controlType: 'Static Text',
        controlValues: null,
        visible: true,
      },
      {
        id: 2,
        name: 'YES / NO',
        displayName: 'YES / NO',
        controlType: 'Dropdown',
        controlValues: ['YES', 'NO'],
        visible: true,
      },
      {
        id: 3,
        name: 'REMARKS - Required if Structured Round is not completed',
        displayName: 'REMARKS - Required if Structured Round is not completed',
        controlType: 'Text',
        controlValues: null,
        visible: true,
      },
    ],
  },
  data: [
    {
      rollupDetails: null,
      rowCount: 1,
      rowData: [
        {
          ITEM: 'Full Structured Rounds Completed',
          'YES / NO': 'YES',
          'REMARKS - Required if Structured Round is not completed': null,
        },
      ],
    },
  ],
  count: 0,
  groupSnippets: null,
};
